module.exports = __webpack_public_path__ + "img/Guinea.1b4c0484.svg";